var site = site || {};

site.gotL2Cache = false;

(function ($) {
  var productContentGridV1 = {
    $template: $('.product-content-grid-v1'),

    init: function () {
      var self = this;
      // Default 3-column
      var columns = 3;

      // Uncomment for testing 3-column when using 5-column as test data
      // $('.product-content-grid-v1').removeClass('columns-5').addClass('columns-3');

      self.$template.each(function () {
        var $me = $(this);

        // re-draw with L2 cache
        $(document).on('inventory_status_stored', function () {
          productContentGridV1.cleanAndDisplay($me);
          site.gotL2Cache = true;
        });

        // if we already have L2 cache...
        if (site.gotL2Cache) {
          productContentGridV1.cleanAndDisplay($me);
        }
      });
    },
    cleanAndDisplay: function ($me) {
    // weed out any products that lack 'isOrderable' or 'Coming Soon' skus
      $(page_data['product-input-type'].products).each(function (i, product) {
        if (typeof product.skus !== 'undefined') {
          var isOrderableSku = $(product.skus).filter(function () {
            if (typeof $(document).data(this.SKU_ID) != 'undefined') {
              return ($(document).data(this.SKU_ID).isOrderable == 1)
                  || ($(document).data(this.SKU_ID).INVENTORY_STATUS == 3);
            }
          })[0];

          if (typeof isOrderableSku == 'undefined') {
          // remove product - removed completely so the quickshop positioning remains correct
            $('.pcg-product-v1 .product[data-productid="' + product.PRODUCT_ID + '"]').parents('li').remove();
          } else {
            $('.pcg-product-v1 .product[data-productid="' + product.PRODUCT_ID + '"]').addClass('hasValidSku');
          }
        }
      });
      // remove those that lack any skus, let alone any valid ones...
      // $('.pcg-product-v1 .product[data-productid]').not('.hasValidSku').parents('li').remove();

      // 5-column
      var columns = 3;

      if ($me.hasClass('columns-5')) {
        columns = 5;
      }

      // Set up rows
      var $items = $me.find('li'),
        $iLen = $items.length;

      for (var i = 0; i < $iLen; i += columns) {
        $items.slice(i, i + columns).wrapAll('<div class="row"></div>');
      }

      // Set the height of the columns within each row
      $me.find('.row').each(function () {
        var $cols = $(this).find('li'),
          ch = 0;

        $(window).resize(function () {
          $cols.each(function () {
            var $el = $(this);

            $el.css({ height: 'auto' });
            var h = $el.outerHeight(true);

            if (h > ch) {
              ch = h;
              $(window).resize();

              return;
            }
            // }).css('height', (ch) + 'px');
          }).height(ch);
        }).resize();
      });

      $items.each(function (i) {
        $(this).prepend('<div class="number">' + (i + 1) + '</div>');
      });
    }
  };

  $(window).on('load', function() {
    productContentGridV1.init();
  });
})(jQuery);
